import {
  Component,
  EventEmitter,
  HostListener,
  OnInit,
  Output
} from '@angular/core'

import { environment } from '../../../../../environments/environment'

@Component({
  selector: 'app-image-gallery-modal',
  templateUrl: './image-gallery-modal.component.html',
  styleUrls: ['./image-gallery-modal.component.scss']
})
export class ImageGalleryModalComponent implements OnInit {
  @Output() modalClosed: EventEmitter<string> = new EventEmitter()

  images: string[] = [
    'default/8dab1dizlfgyc79d',
    'default/8dab1dizlfgycfof',
    'default/8dab1dizlfgyj872',
    'default/8dab1dizlfgyj2ao',
    'default/8dab1dizlfgyiuwe',
    'default/8dab1dizlfgyiqds',
    'default/8dab1dizlfgyikt2',
    'default/8dab1dizlfgyiepb',
    'default/8dab1dizlfgyi4vb',
    'default/8dab1dizlfgyhr0t',
    'default/8dab1dizlfgyhcri',
    'default/8dab1dizlfgyh1mq',
    'default/8dab1dizlfgygx1a',
    'default/8dab1dizlfgygn21',
    'default/8dab1dizlfgygii4',
    'default/8dab1dizlfgyfuov',
    'default/8dab1dizlfgyfqhf',
    'default/8dab1dizlfgyflli',
    'default/8dab1dizlfgyfg1j',
    'default/8dab1dizlfgyfbs8',
    'default/8dab1dizlfgyf6yd',
    'default/8dab1dizlfgyf2wd',
    'default/8dab1dizlfgyexl0',
    'default/8dab1dizlfgyer48',
    'default/8dab1dizlfgyekrw',
    'default/8dab1dizlfgyeeen',
    'default/8dab1dizlfgydv9x',
    'default/8dab1dizlfgye7c2',
    'default/8dab1dizlfgydkz8',
    'default/8dab1dizlfgyddnb',
    'default/8dab1dizlfgyd9j6',
    'default/8dab1dizlfgyd2w2',
    'default/8dab1dizlfgycxic',
    'default/8dab1dizlfgyctja',
    'default/8dab1dizlfgycpbh',
    'default/8dab1dizlfgzdcrs',
    'default/8dab1dizlfgzdhcn',
    'default/8dab1dizlfgzdku0',
    'default/8dab1dizlfgzdntq',
    'default/8dab1dizlfgzdrs5',
    'default/8dab1dizlfgzduwa',
    'default/8dab1dizlfgzdxim',
    'default/8dab1dizlfgze0aq',
    'default/8dab1dizlfgze6ak',
    'default/8dab1dizlfgze9b9',
    'default/8dab1dizlfgzecct',
    'default/8dab1dizlfgzecct',
    'default/8dab1dizlfgzeg2h'
  ]
  selectedImage: string
  storagePath: string = environment.apiCatalogStoragePath

  ngOnInit() {
    this.images = this.shuffle(this.images)
  }

  selectImage(image: string) {
    this.selectedImage = image
  }

  confirmSelection() {
    this.modalClosed.emit(this.selectedImage) // We emit the image name without extension.
  }

  private shuffle(array: string[]) {
    let currentIndex: number = array.length
    let randomIndex: number

    while (currentIndex != 0) {
      randomIndex = Math.floor(Math.random() * currentIndex)
      currentIndex--
      ;[array[currentIndex], array[randomIndex]] = [
        array[randomIndex],
        array[currentIndex]
      ]
    }

    return array
  }

  @HostListener('document:click', ['$event.target'])
  onClick(target: any) {
    if (target.className === 'modal-background') {
      this.modalClosed.emit()
    }
  }
}
